import * as React from 'react'

import { styled, spacing, mq } from '@thg-commerce/enterprise-theme'

import { HeaderGroup } from '../../HeaderGroup'

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: ${(props) => props.theme.colors.palette.greys.white};
`

const HeaderGroupContainer = styled.div`
  position: relative;
  flex-grow: 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    height: ${spacing(9)};
    margin-bottom: ${spacing(8)};
  }
`

export const ErrorLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <PageContainer>
      <HeaderGroupContainer>
        <HeaderGroup
          wishlistNotification={true}
          stickyHeader={false}
          showWishlistButton={false}
        />
      </HeaderGroupContainer>
      <main
        id="main-content"
        style={{
          flexGrow: 1,
        }}
      >
        {children}
      </main>
    </PageContainer>
  )
}
